import React from "react";
import { Warning } from "@mui/icons-material";
import {
  Slide,
  Typography,
  Stack,
  Box,
  SlideProps,
  SxProps,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Button, { UnionType } from "@common/components/Button";

type SlideUnsavedProps = Required<Pick<SlideProps, "direction">> & {
  warning: boolean;
  onClose: () => void;
  onCancel: () => void;
  sx?: SxProps;
};

const SlideUnsaved = (props: SlideUnsavedProps) => {
  const { t } = useTranslation();
  const { warning, direction, onClose, onCancel, sx = { top: 0 } } = props;

  const buttons: UnionType[] = [
    {
      onClick: onClose,
      color: "white",
      variant: "contained",
      children: t("Discard"),
      "data-testid": "discard-button",
    },
    {
      onClick: onCancel,
      variant: "outlined",
      color: "greyed",
      children: t("Go back"),
      "data-testid": "go-back-button",
    },
  ];

  return (
    <Slide direction={direction} in={warning} mountOnEnter unmountOnExit>
      <Stack
        direction="row"
        sx={{
          position: "absolute",
          width: "100%",
          justifyContent: "space-between",
          p: 1,
          backgroundColor: (theme) => theme.palette.background.paper,
          zIndex: 1,
          ...sx,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}
        >
          <Warning color="error" />
          <Typography>{t("All unsaved data will be lost.")}</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}
        >
          {buttons.map((btnProps, index) => (
            <Button key={index} {...btnProps} weighted />
          ))}
        </Box>
      </Stack>
    </Slide>
  );
};

export default SlideUnsaved;
